// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import {
    GeoRecordCategoryIcon
} from '@/vue3/api/models/geoRecordCategoryIconModels';

export const useGeoRecordCategoryIconService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive
    const geoRecordCategoryIcons = ref<GeoRecordCategoryIcon[]>([]);

    // methods
    const getAllGeoRecordCategoryIcon = async (): Promise<GeoRecordCategoryIcon[]> => {
        const res = await axios.get(`${apiUrl}/geo-record-category-icon`);
        geoRecordCategoryIcons.value = res.data;
        return res.data;
    };

    const submitGeoRecordCategoryIcon = async (images: any): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/geo-record-category-icon`,
            images,
        );
        if(res.status == 200 || res.status == 201){
            return true;
        }
        return false;
    };

    const getPermittedIconFileNames = async () => {
        const res = await axios.get(
            `${apiUrl}/geo-record-category-icon/file-names`,
        );
        return res.data;
    };

    return {
        getAllGeoRecordCategoryIcon,
        submitGeoRecordCategoryIcon,
        getPermittedIconFileNames
    };
};
